module.exports = "https://health.dajiuxing.com.cn/img/assets/img/chineseMedicine/officialaccount.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2FchineseMedicine%2Fofficialaccount.jpg
// module id = WRzd
// module chunks = 93